import { memo } from 'react';

import { Box } from '@hivebrite/design-system/Box';

import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import type { FrameChild } from 'hb-builder/components/RenderComponents/page/block/Strips/types/items';
import { ChildrenRenderer } from 'hb-builder/components/Renderer/ChildrenRenderer';
import StripsSliderUI from 'hb-builder/components/UIComponents/page/block/Strips/StripsSlider/StripsSliderUI';
import type { RenderComponent } from 'hb-builder/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { StripsItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/stripsItemAttributes';

const StripsSlider: RenderComponent = () => <div />; // never used

interface ChildMemoProps {
  childItem: FrameChild;
}

const ChildMemo = memo(
  ({ childItem }: ChildMemoProps) => (
    <Box flexDirection="column" height="100%" width="100%">
      <ChildrenRenderer item={{ children: [childItem] }} />
    </Box>
  ),
  () => true,
);

const Render = ({
  item = { id: '', type: '' },
}: RenderProps<DocumentItem<StripsItemAttributes>>) => (
  <StripsSliderUI
    renderItem={(childItem) => <ChildMemo childItem={childItem} />}
    stripSlider={item}
  />
);

StripsSlider.componentName = 'StripsSlider';
StripsSlider.Render = Render;

export default StripsSlider;
